module.exports = __webpack_public_path__ + "static/elijah_stanger_jones-e68e5d000a0f7192acd665a4f388dcdd.png";